/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';

const propTypes = {
  children: React.PropTypes.node.isRequired,
};

const QualityView = props => (
  <div>
    {props.children}
  </div>
);

QualityView.propTypes = propTypes;

export default QualityView;




// WEBPACK FOOTER //
// ./src/containers/Network/coms/QualityView/index.jsx